// extracted by mini-css-extract-plugin
export default {"app-root":"e87f2f","loading-spinner":"dc6b43"};